import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Badge,
  Button,
  Header,
  HorizontalStack,
  Icon,
  Image,
  KCarousel,
  KCol,
  KContentMenu,
  KContentMenuItem,
  KContentMenuPanel,
  KDrawer,
  KGallery,
  KModal,
  KPanel,
  KRow,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  TextInput,
  Tooltip,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { AnaSayfa_ScreenBase } from "./anasayfa-base";

import { InlineFormScope } from "../../routes/master-screen-wrapper";
import { ProoductDetail_Screen } from "../prooductdetail/prooductdetail";
import { SepetModal_Screen } from "../sepetmodal/sepetmodal";
import { SiparisDetay_Screen } from "../siparisdetay/siparisdetay";
import { SiparisSepetOzet_Screen } from "../siparissepetozet/siparissepetozet";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class AnaSayfa_Screen extends AnaSayfa_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin
          spinning={
            this.state.spinnerCount > 0 ||
            (!!this.context?.callCallbackFunction &&
              !this.context?.isMasterPageInitLoaded &&
              !this.state.isPageInitLoaded)
          }
        >
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              component={false}
              initialValues={{
                anasayfa_317000_value: undefined,
                anasayfa_972835_value: "c1feb4eb-c59d-4cbe-66b7-08dda35b6908",
                anasayfa_299678_value: "b4793da4-c547-4f51-1dda-08de233f80a5",
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div
                style={
                  {
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                  } as any
                }
              >
                <Header
                  key="-2"
                  id="anasayfa_header"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="520225"
                    id="520225"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "left",
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "center",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="960662"
                      id="960662"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={10}
                      xxl={10}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          alignItems: "center",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="28454"
                        id="28454"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="495174"
                          id="495174"
                          xs={23}
                          sm={23}
                          md={23}
                          lg={23}
                          xl={23}
                          xxl={23}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderTopLeftRadius: 10,
                              borderTopRightRadius: 10,
                              borderBottomRightRadius: 10,
                              borderBottomLeftRadius: 10,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              paddingLeft: 0,
                              alignItems: "center",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <HorizontalStack
                            key="399508"
                            id="399508"
                            direction="horizontal"
                            size={12}
                            overflowX="auto"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Icon
                              key="74134"
                              id="74134"
                              iconName="search"
                              iconLibrary="material"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 10,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "20px",
                                  color: "rgba(72, 72, 72, 1)",
                                  letterSpacing: "1px",
                                } as any
                              }
                            ></Icon>
                            <Form.Item
                              className="kFormItem"
                              name="anasayfa_317000_value"
                            >
                              <TextInput
                                key="317000"
                                id="317000"
                                onPressEnter={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.AnaSayfaComponent_317000_onPressEnter();
                                }}
                                kuikaRef={
                                  this.anasayfa_317000_value_kuikaTextInputRef
                                }
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  317000,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                bordered={true}
                                disabled={false}
                                type="text"
                                iconColor="rgba(0, 0, 0, 1)"
                                formatter="None"
                                isCharOnly={false}
                                autoComplete={true}
                                inputMode="all"
                                speechToText={false}
                                style={
                                  {
                                    borderColor: "rgba(217, 217, 217, 1)",
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    width: "21vw",
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    color: "rgba(144, 144, 144, 1)",
                                  } as any
                                }
                              ></TextInput>
                            </Form.Item>
                          </HorizontalStack>
                        </KCol>
                      </KRow>
                    </KCol>
                    <KCol
                      key="848835"
                      id="848835"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={14}
                      xxl={14}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="221112"
                        id="221112"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="917863"
                          id="917863"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              alignItems: "center",
                              textAlign: "-webkit-right",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <HorizontalStack
                            key="385973"
                            id="385973"
                            direction="horizontal"
                            size={10}
                            overflowX="auto"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="anasayfa_30105_value"
                              noStyle
                            >
                              <Badge
                                key="30105"
                                id="30105"
                                count={
                                  this.state.GetToplamTeklifSepeti?.at?.(0)
                                    ?.toplamTeklifSepeti ?? undefined
                                }
                                showZero={false}
                                overflowCount={100}
                                dot={false}
                                iconLibrary="material"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    color: "rgba(255, 255, 255, 1)",
                                    lineHeight: "20px",
                                  } as any
                                }
                              >
                                <Icon
                                  key="692983"
                                  id="692983"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_692983_onClick();
                                  }}
                                  showCursorPointer
                                  visibility={this.state.isComp692983Visible}
                                  iconName="shopping_basket"
                                  iconLibrary="material"
                                  style={
                                    {
                                      borderTopLeftRadius: 7,
                                      borderTopRightRadius: 7,
                                      borderBottomRightRadius: 7,
                                      borderBottomLeftRadius: 7,
                                      borderColor: "rgba(178, 14, 14, 0.26)",
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(72, 72, 72, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "15px",
                                      color: "rgba(255, 255, 255, 1)",
                                      letterSpacing: "1px",
                                    } as any
                                  }
                                ></Icon>
                              </Badge>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="anasayfa_21550_value"
                              noStyle
                            >
                              <Badge
                                key="21550"
                                id="21550"
                                count={
                                  this.state.GetToplamSiparisSepetUrunSayisi?.at?.(
                                    0
                                  )?.toplamSiparisSepeti ?? undefined
                                }
                                showZero={false}
                                overflowCount={100}
                                dot={false}
                                iconLibrary="material"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    color: "rgba(255, 255, 255, 1)",
                                    lineHeight: "20px",
                                  } as any
                                }
                              >
                                <Icon
                                  key="971668"
                                  id="971668"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_971668_onClick();
                                  }}
                                  showCursorPointer
                                  iconName="shopping_cart"
                                  iconLibrary="material"
                                  style={
                                    {
                                      borderTopLeftRadius: 7,
                                      borderTopRightRadius: 7,
                                      borderBottomRightRadius: 7,
                                      borderBottomLeftRadius: 7,
                                      borderColor: "rgba(178, 14, 14, 0.26)",
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(72, 72, 72, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "15px",
                                      color: "rgba(255, 255, 255, 1)",
                                      letterSpacing: "1px",
                                    } as any
                                  }
                                ></Icon>
                              </Badge>
                            </Form.Item>

                            <Form.Item
                              className="kFormItem"
                              name="anasayfa_338785_value"
                              noStyle
                            >
                              <Badge
                                key="338785"
                                id="338785"
                                count="0"
                                showZero={false}
                                overflowCount={100}
                                dot={false}
                                iconLibrary="material"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    color: "rgba(255, 255, 255, 1)",
                                    lineHeight: "20px",
                                  } as any
                                }
                              >
                                <Icon
                                  key="3340"
                                  id="3340"
                                  iconName="notifications_active"
                                  iconLibrary="material"
                                  style={
                                    {
                                      borderTopLeftRadius: 7,
                                      borderTopRightRadius: 7,
                                      borderBottomRightRadius: 7,
                                      borderBottomLeftRadius: 7,
                                      borderColor: "rgba(178, 14, 14, 0.26)",
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(72, 72, 72, 1)",
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      display: "inline",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "15px",
                                      color: "rgba(255, 255, 255, 1)",
                                      letterSpacing: "1px",
                                    } as any
                                  }
                                ></Icon>
                              </Badge>
                            </Form.Item>
                            <HorizontalStack
                              key="728965"
                              id="728965"
                              direction="horizontal"
                              size={1}
                              overflowX="auto"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KContentMenu
                                key="238748"
                                id="238748"
                                menuOpeningType="hover"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KContentMenuPanel
                                  key="229598"
                                  id="229598"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Icon
                                    key="962344"
                                    id="962344"
                                    iconName="language"
                                    iconLibrary="material"
                                    style={
                                      {
                                        borderTopLeftRadius: 7,
                                        borderTopRightRadius: 7,
                                        borderBottomRightRadius: 7,
                                        borderBottomLeftRadius: 7,
                                        borderColor: "rgba(178, 14, 14, 0.26)",
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor: "rgba(252, 17, 22, 1)",
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "center",
                                        textAlign: "-webkit-left",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "15px",
                                        color: "rgba(255, 255, 255, 1)",
                                        letterSpacing: "1px",
                                      } as any
                                    }
                                  ></Icon>
                                </KContentMenuPanel>
                                <KContentMenuItem
                                  key="733891"
                                  id="733891"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_733891_onClick();
                                  }}
                                  showCursorPointer
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    733891,
                                    "label",
                                    this.defaultML
                                  )}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KContentMenuItem>
                                <KContentMenuItem
                                  key="117303"
                                  id="117303"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_117303_onClick();
                                  }}
                                  showCursorPointer
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    117303,
                                    "label",
                                    this.defaultML
                                  )}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KContentMenuItem>
                                <KContentMenuItem
                                  key="852364"
                                  id="852364"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_852364_onClick();
                                  }}
                                  showCursorPointer
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    852364,
                                    "label",
                                    this.defaultML
                                  )}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KContentMenuItem>
                                <KContentMenuItem
                                  key="55820"
                                  id="55820"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_55820_onClick();
                                  }}
                                  showCursorPointer
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    55820,
                                    "label",
                                    this.defaultML
                                  )}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KContentMenuItem>
                              </KContentMenu>
                              <KContentMenu
                                key="144592"
                                id="144592"
                                menuOpeningType="hover"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KContentMenuPanel
                                  key="988308"
                                  id="988308"
                                  style={
                                    {
                                      borderTopLeftRadius: 8,
                                      borderTopRightRadius: 8,
                                      borderBottomRightRadius: 8,
                                      borderBottomLeftRadius: 8,
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <Form.Item
                                    className="kFormItem"
                                    name="anasayfa_972835_value"
                                  >
                                    <Image
                                      key="972835"
                                      id="972835"
                                      placeHolderImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/9sAQwABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEB/8AACwgANgBgAQERAP/EABkAAQADAQEAAAAAAAAAAAAAAAAEBQYHCv/EACoQAAEEAgMBAAADCQAAAAAAAAIAAwQFAQYREhMUByEiJDEzNjd1drS1/9oACAEBAAA/APWAiIiIiIiIiIiIiIiIiIqTZrU6HXNgvGmQkO01Ja2rbDhZAHzroD8wGTMeSAHCawBEOM5HBFnHOccKmbpdyyAZe3Zv2yI+vhrVeDHpxjv4g9JfdBrtz5i6+84IcYN1wsZMsq9c25FeRqnf4064oIdhNODN1IW4EvNSWG5zDcttyCE9qLKy3XWjlRPecqpb4MTMsysgyfUq6X99fAnefl9sOLL8u3fz+lgHvPv1Ht079e3Ue3HPGOeFMRERERY78RP6f71/h2z/APEnKlnWG4VVfI2+xkw40SL3lS9Od+BtqPTYHH6BvCHDh7QP8XqUrNG88WKdoBzlu7Wcfk1dY1d3kzU5Ott7TWXLNbbS7CU/jD9jg5BRbKnex8unzdkl4ZneMbsNrPFlu5dZvMx4jvVdc/l6h/s1X/osK5RERERV1xVx7uotKWWTgxbeunVcomSEXhjz4zsR4miITEXMNullssgY4LjORLGM4WAk6hu8+XVS7LctcsBpwA40OTo9h8Dtk3x53UuNG3mOMiyaxgvm7fsMNwykQ4LEkQfCxs9e3O6rp1RZbLqxV9nFfgzcRdHsG5XzSWyadzGcm7xZQ25AgWSYckwJjLbuANyM8I5AtvEjNQosaGx28IkdmMz2z2LyYbFpvsXGOxdAxznGMc5/PjH7lIREREREREREREREREREX//Z"
                                      zoomOnClick={false}
                                      imageFit="stretch"
                                      style={
                                        {
                                          borderTopLeftRadius: 32,
                                          borderTopRightRadius: 32,
                                          borderBottomRightRadius: 32,
                                          borderBottomLeftRadius: 32,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          width: "40px",
                                          height: "40px",
                                          maxWidth: "300px",
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    ></Image>
                                  </Form.Item>
                                  <Button
                                    key="683174"
                                    id="683174"
                                    label={
                                      this.state.GetKullanici?.at?.(0)
                                        ?.adSoyad ?? undefined
                                    }
                                    size="middle"
                                    loading={false}
                                    ghost={false}
                                    block={false}
                                    htmlType="button"
                                    icon="expand_more"
                                    iconPosition="right"
                                    danger={false}
                                    iconLibrary="material"
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        backgroundColor:
                                          "rgba(244, 244, 244, 1)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        backgroundPosition: "left",
                                        paddingTop: 8,
                                        paddingRight: 16,
                                        paddingBottom: 8,
                                        paddingLeft: 16,
                                        alignItems: "center",
                                        textAlign: "-webkit-center",
                                        display: "inline",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  ></Button>
                                </KContentMenuPanel>
                                <KContentMenuItem
                                  key="102679"
                                  id="102679"
                                  label={
                                    this.state.GetCariBilgileri?.at?.(0)
                                      ?.carI_ISIM ?? undefined
                                  }
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KContentMenuItem>
                                <KContentMenuItem
                                  key="404060"
                                  id="404060"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.AnaSayfaComponent_404060_onClick();
                                  }}
                                  showCursorPointer
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    404060,
                                    "label",
                                    this.defaultML
                                  )}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                      alignItems: "center",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                ></KContentMenuItem>
                              </KContentMenu>
                            </HorizontalStack>
                          </HorizontalStack>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                </Header>
                <div
                  key="-1"
                  id="anasayfa_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(244, 244, 244, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                      overflow: "auto",
                      minHeight:
                        "calc(100vh - 85px - 60px - 0px - 0px - 0px - 0px)",
                      maxHeight:
                        "calc(100vh - 85px - 60px - 0px - 0px - 0px - 0px)",
                      height:
                        "calc(100vh - 85px - 60px - 0px - 0px - 0px - 0px)",
                    } as any
                  }
                >
                  <KRow
                    key="42469"
                    id="42469"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="310114"
                      id="310114"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KPanel
                        key="946231"
                        id="946231"
                        scrolling="hidden"
                        scrollRadius={false}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KRow
                          key="173537"
                          id="173537"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="689476"
                            id="689476"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KRow
                              key="305484"
                              id="305484"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="733334"
                                id="733334"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KRow
                                  key="577197"
                                  id="577197"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 0,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="393437"
                                    id="393437"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 0,
                                        paddingBottom: 8,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="669600"
                                      id="669600"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="163668"
                                        id="163668"
                                        xs={24}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={5}
                                        xxl={5}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="98459"
                                          id="98459"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="175559"
                                            id="175559"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="884027"
                                              id="884027"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="841012"
                                                id="841012"
                                                xs={16}
                                                sm={16}
                                                md={16}
                                                lg={16}
                                                xl={16}
                                                xxl={16}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="107477"
                                                  id="107477"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    107477,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="244490"
                                                id="244490"
                                                xs={8}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={8}
                                                xxl={8}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="529572"
                                                  id="529572"
                                                  iconName="shopping_cart"
                                                  iconLibrary="material"
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 7,
                                                      borderTopRightRadius: 7,
                                                      borderBottomRightRadius: 7,
                                                      borderBottomLeftRadius: 7,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(251, 18, 22, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="669752"
                                              id="669752"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="198095"
                                                id="198095"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 16,
                                                    paddingRight: 16,
                                                    paddingBottom: 0,
                                                    paddingLeft: 16,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="642068"
                                                  id="642068"
                                                  value={
                                                    this.state.ToplamSiparisSayisi?.at?.(
                                                      0
                                                    )?.toplamSiparis ??
                                                    undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Montserrat",
                                                      fontWeight: 600,
                                                      fontSize: "20px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="433687"
                                              id="433687"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="796691"
                                                id="796691"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.AnaSayfaComponent_796691_onClick();
                                                }}
                                                showCursorPointer
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="27533"
                                                  id="27533"
                                                  direction="horizontal"
                                                  size={8}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="102789"
                                                    id="102789"
                                                    iconName="arrow_forward_ios"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="941190"
                                                    id="941190"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      941190,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                      <KCol
                                        key="437062"
                                        id="437062"
                                        xs={24}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={7}
                                        xxl={7}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="688184"
                                          id="688184"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="745535"
                                            id="745535"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="288296"
                                              id="288296"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="88323"
                                                id="88323"
                                                xs={16}
                                                sm={16}
                                                md={16}
                                                lg={16}
                                                xl={16}
                                                xxl={16}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="522785"
                                                  id="522785"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    522785,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="55116"
                                                id="55116"
                                                xs={8}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={8}
                                                xxl={8}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="128734"
                                                  id="128734"
                                                  iconName="shopping_cart"
                                                  iconLibrary="material"
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 7,
                                                      borderTopRightRadius: 7,
                                                      borderBottomRightRadius: 7,
                                                      borderBottomLeftRadius: 7,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(251, 18, 22, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="115728"
                                              id="115728"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="334997"
                                                id="334997"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 16,
                                                    paddingRight: 16,
                                                    paddingBottom: 0,
                                                    paddingLeft: 16,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="756076"
                                                  id="756076"
                                                  value={
                                                    this.state.GetCariParaBirimi?.at?.(
                                                      0
                                                    )?.paraSembol ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 10,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Montserrat",
                                                      fontWeight: 600,
                                                      fontSize: "20px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="736604"
                                                  id="736604"
                                                  value={
                                                    this.state.CariEkstreToplam?.at?.(
                                                      0
                                                    )?.bakiye ?? undefined
                                                  }
                                                  formatter="money"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Montserrat",
                                                      fontWeight: 600,
                                                      fontSize: "20px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="472375"
                                              id="472375"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="242927"
                                                id="242927"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.AnaSayfaComponent_242927_onClick();
                                                }}
                                                showCursorPointer
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="284838"
                                                  id="284838"
                                                  direction="horizontal"
                                                  size={8}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="72030"
                                                    id="72030"
                                                    iconName="arrow_forward_ios"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="989658"
                                                    id="989658"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      989658,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                      <KCol
                                        key="865853"
                                        id="865853"
                                        xs={24}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        xxl={12}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="283884"
                                          id="283884"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="660440"
                                            id="660440"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="366302"
                                              id="366302"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="101201"
                                                id="101201"
                                                xs={8}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 8,
                                                    paddingLeft: 0,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Form.Item
                                                  className="kFormItem"
                                                  name="anasayfa_745370_value"
                                                  noStyle
                                                >
                                                  <KCarousel
                                                    key="745370"
                                                    id="745370"
                                                    kuikaRef={
                                                      this
                                                        .anasayfa_745370_value_kuikaCarouselRef
                                                    }
                                                    nodatafoundmessage={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      745370,
                                                      "nodatafoundmessage",
                                                      this.defaultML
                                                    )}
                                                    dataSource={
                                                      this.state
                                                        .GetKampanyaliUrunler
                                                    }
                                                    fade={false}
                                                    hoverFontColor="rgba(0, 0, 0, 1)"
                                                    hoverBgColor="rgba(255, 255, 255, 1)"
                                                    slidesToScroll={1}
                                                    slidesToShow={1}
                                                    swipe={false}
                                                    vertical={false}
                                                    pauseOnDotsHover={true}
                                                    autoplay={true}
                                                    autoplaySpeed={4000}
                                                    dots={true}
                                                    showNoDataFoundImage={false}
                                                    showPageIndicator={false}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KRow
                                                      key="203195"
                                                      id="203195"
                                                      align="top"
                                                      justify="start"
                                                      horizontalGutter={0}
                                                      verticalGutter={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          backgroundRepeat:
                                                            "no-repeat",
                                                          backgroundSize:
                                                            "cover",
                                                          backgroundPosition:
                                                            "center",
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 0,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <KCol
                                                        key="106919"
                                                        id="106919"
                                                        xs={14}
                                                        sm={14}
                                                        md={14}
                                                        lg={14}
                                                        xl={14}
                                                        xxl={14}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <KRow
                                                          key="391832"
                                                          id="391832"
                                                          align="top"
                                                          justify="start"
                                                          horizontalGutter={0}
                                                          verticalGutter={0}
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              backgroundRepeat:
                                                                "no-repeat",
                                                              backgroundSize:
                                                                "cover",
                                                              backgroundPosition:
                                                                "left",
                                                              paddingTop: 0,
                                                              paddingRight: 8,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign:
                                                                "-webkit-left",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <KCol
                                                            key="979323"
                                                            id="979323"
                                                            xs={24}
                                                            sm={24}
                                                            md={24}
                                                            lg={24}
                                                            xl={24}
                                                            xxl={24}
                                                            order={0}
                                                            pull={0}
                                                            push={0}
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 10,
                                                                paddingRight: 8,
                                                                paddingBottom: 0,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="899822"
                                                              id="899822"
                                                              value={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                899822,
                                                                "value",
                                                                this.defaultML
                                                              )}
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "13px",
                                                                  color:
                                                                    "rgba(252, 17, 22, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </KCol>
                                                          <KCol
                                                            key="185205"
                                                            id="185205"
                                                            xs={24}
                                                            sm={24}
                                                            md={24}
                                                            lg={24}
                                                            xl={24}
                                                            xxl={24}
                                                            order={0}
                                                            pull={0}
                                                            push={0}
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 8,
                                                                paddingRight: 8,
                                                                paddingBottom: 8,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <VerticalStack
                                                              key="778105"
                                                              id="778105"
                                                              direction="vertical"
                                                              size={2}
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "rgba(68, 68, 68, 1)",
                                                                } as any
                                                              }
                                                            >
                                                              <Label
                                                                key="149062"
                                                                id="149062"
                                                                value="[datafield:stoK_KODU]"
                                                                writingMode="horizontal"
                                                                style={
                                                                  {
                                                                    borderStyle:
                                                                      "solid",
                                                                    borderTopWidth: 0,
                                                                    borderRightWidth: 0,
                                                                    borderBottomWidth: 0,
                                                                    borderLeftWidth: 0,
                                                                    paddingTop: 0,
                                                                    paddingRight: 0,
                                                                    paddingBottom: 0,
                                                                    paddingLeft: 0,
                                                                    alignItems:
                                                                      "center",
                                                                    textAlign:
                                                                      "-webkit-left",
                                                                    display:
                                                                      "inline",
                                                                    fontFamily:
                                                                      "Poppins",
                                                                    fontWeight: 600,
                                                                    fontSize:
                                                                      "12px",
                                                                    color:
                                                                      "rgba(155, 155, 155, 1)",
                                                                    lineHeight:
                                                                      "20px",
                                                                  } as any
                                                                }
                                                              ></Label>
                                                              <Label
                                                                key="507198"
                                                                id="507198"
                                                                value="[datafield:adetBazliFiyatAciklama]"
                                                                writingMode="horizontal"
                                                                style={
                                                                  {
                                                                    borderStyle:
                                                                      "solid",
                                                                    borderTopWidth: 0,
                                                                    borderRightWidth: 0,
                                                                    borderBottomWidth: 0,
                                                                    borderLeftWidth: 0,
                                                                    paddingTop: 0,
                                                                    paddingRight: 0,
                                                                    paddingBottom: 0,
                                                                    paddingLeft: 0,
                                                                    alignItems:
                                                                      "center",
                                                                    textAlign:
                                                                      "-webkit-left",
                                                                    display:
                                                                      "inline",
                                                                    fontFamily:
                                                                      "Poppins",
                                                                    fontWeight: 600,
                                                                    fontSize:
                                                                      "12px",
                                                                    color:
                                                                      "rgba(155, 155, 155, 1)",
                                                                    lineHeight:
                                                                      "20px",
                                                                  } as any
                                                                }
                                                              ></Label>
                                                            </VerticalStack>
                                                          </KCol>
                                                          <KCol
                                                            key="442410"
                                                            id="442410"
                                                            xs={24}
                                                            sm={24}
                                                            md={24}
                                                            lg={24}
                                                            xl={24}
                                                            xxl={24}
                                                            order={0}
                                                            pull={0}
                                                            push={0}
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 8,
                                                                paddingBottom: 0,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Button
                                                              key="554333"
                                                              id="554333"
                                                              onClick={(
                                                                e?: any
                                                              ) => {
                                                                if (
                                                                  e &&
                                                                  e.stopPropagation
                                                                )
                                                                  e.stopPropagation();
                                                                this.AnaSayfaComponent_554333_onClick();
                                                              }}
                                                              showCursorPointer
                                                              label={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                554333,
                                                                "label",
                                                                this.defaultML
                                                              )}
                                                              size="middle"
                                                              loading={false}
                                                              ghost={false}
                                                              block={false}
                                                              htmlType="button"
                                                              icon="zoom_in"
                                                              iconPosition="left"
                                                              danger={false}
                                                              iconLibrary="material"
                                                              style={
                                                                {
                                                                  borderTopLeftRadius: 10,
                                                                  borderTopRightRadius: 10,
                                                                  borderBottomRightRadius: 10,
                                                                  borderBottomLeftRadius: 10,
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  backgroundColor:
                                                                    "rgba(252, 17, 22, 1)",
                                                                  backgroundRepeat:
                                                                    "no-repeat",
                                                                  backgroundSize:
                                                                    "contain",
                                                                  backgroundPosition:
                                                                    "left",
                                                                  paddingTop: 8,
                                                                  paddingRight: 16,
                                                                  paddingBottom: 8,
                                                                  paddingLeft: 16,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-center",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "12px",
                                                                  color:
                                                                    "rgba(255, 255, 255, 1)",
                                                                  lineHeight:
                                                                    "22px",
                                                                } as any
                                                              }
                                                            ></Button>
                                                          </KCol>
                                                        </KRow>
                                                      </KCol>
                                                      <KCol
                                                        key="639005"
                                                        id="639005"
                                                        xs={10}
                                                        sm={10}
                                                        md={10}
                                                        lg={10}
                                                        xl={10}
                                                        xxl={10}
                                                        order={0}
                                                        pull={0}
                                                        push={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingRight: 15,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-right",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <Form.Item
                                                          className="kFormItem"
                                                          name="anasayfa_422152_value"
                                                        >
                                                          <Image
                                                            key="422152"
                                                            id="422152"
                                                            value="[datafield:kapakResim]"
                                                            placeHolderImage="f4b5fbbd-9e25-402c-9581-08dd8e436860"
                                                            zoomOnClick={false}
                                                            imageFit="fill"
                                                            style={
                                                              {
                                                                borderTopLeftRadius: 8,
                                                                borderTopRightRadius: 8,
                                                                borderBottomRightRadius: 8,
                                                                borderBottomLeftRadius: 8,
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                width: "100px",
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          ></Image>
                                                        </Form.Item>
                                                      </KCol>
                                                    </KRow>
                                                  </KCarousel>
                                                </Form.Item>
                                                <KRow
                                                  key="913183"
                                                  id="913183"
                                                  visibility={
                                                    this.state
                                                      .isComp913183Visible
                                                  }
                                                  align="top"
                                                  justify="start"
                                                  horizontalGutter={0}
                                                  verticalGutter={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 8,
                                                      paddingBottom: 0,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KCol
                                                    key="748468"
                                                    id="748468"
                                                    xs={5}
                                                    sm={5}
                                                    md={5}
                                                    lg={5}
                                                    xl={5}
                                                    xxl={5}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></KCol>
                                                  <KCol
                                                    key="289379"
                                                    id="289379"
                                                    xs={14}
                                                    sm={14}
                                                    md={14}
                                                    lg={14}
                                                    xl={14}
                                                    xxl={14}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-center",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <VerticalStack
                                                      key="110137"
                                                      id="110137"
                                                      direction="vertical"
                                                      size={2}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          textAlign:
                                                            "-webkit-center",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Form.Item
                                                        className="kFormItem"
                                                        name="anasayfa_299678_value"
                                                      >
                                                        <Image
                                                          key="299678"
                                                          id="299678"
                                                          zoomOnClick={false}
                                                          imageFit="fit"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              width: "90px",
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-left",
                                                              display: "inline",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        ></Image>
                                                      </Form.Item>
                                                      <Label
                                                        key="215100"
                                                        id="215100"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          215100,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-center",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                      <Label
                                                        key="452726"
                                                        id="452726"
                                                        value={ReactSystemFunctions.translate(
                                                          this.ml,
                                                          452726,
                                                          "value",
                                                          this.defaultML
                                                        )}
                                                        writingMode="horizontal"
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-center",
                                                            display: "inline",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 400,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(144, 144, 144, 1)",
                                                          } as any
                                                        }
                                                      ></Label>
                                                    </VerticalStack>
                                                  </KCol>
                                                  <KCol
                                                    key="448701"
                                                    id="448701"
                                                    xs={5}
                                                    sm={5}
                                                    md={5}
                                                    lg={5}
                                                    xl={5}
                                                    xxl={5}
                                                    order={0}
                                                    pull={0}
                                                    push={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems:
                                                          "flex-start",
                                                        textAlign:
                                                          "-webkit-left",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></KCol>
                                                </KRow>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="345441"
                                  id="345441"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 8,
                                      paddingBottom: 0,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="583090"
                                    id="583090"
                                    visibility={this.state.isComp583090Visible}
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 0,
                                        paddingBottom: 8,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="234058"
                                      id="234058"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="817452"
                                        id="817452"
                                        xs={24}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={8}
                                        xxl={8}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="586772"
                                          id="586772"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="469352"
                                            id="469352"
                                            visibility={
                                              this.state.isComp469352Visible
                                            }
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="738341"
                                              id="738341"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="703688"
                                                id="703688"
                                                xs={16}
                                                sm={16}
                                                md={16}
                                                lg={16}
                                                xl={16}
                                                xxl={16}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="579883"
                                                  id="579883"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    579883,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="245540"
                                                id="245540"
                                                xs={8}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={8}
                                                xxl={8}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="270670"
                                                  id="270670"
                                                  iconName="sell"
                                                  iconLibrary="material"
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 7,
                                                      borderTopRightRadius: 7,
                                                      borderBottomRightRadius: 7,
                                                      borderBottomLeftRadius: 7,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(251, 18, 22, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="482768"
                                              id="482768"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="181426"
                                                id="181426"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 16,
                                                    paddingRight: 16,
                                                    paddingBottom: 0,
                                                    paddingLeft: 16,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="964860"
                                                  id="964860"
                                                  value={
                                                    this.state.ToplamTeklifSayisi?.at?.(
                                                      0
                                                    )?.toplamTeklif ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Montserrat",
                                                      fontWeight: 600,
                                                      fontSize: "20px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="871724"
                                              id="871724"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="858092"
                                                id="858092"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="368544"
                                                  id="368544"
                                                  direction="horizontal"
                                                  size={8}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="827407"
                                                    id="827407"
                                                    iconName="arrow_forward_ios"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="610546"
                                                    id="610546"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      610546,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                      <KCol
                                        key="691829"
                                        id="691829"
                                        xs={24}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={8}
                                        xxl={8}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="277256"
                                          id="277256"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="986030"
                                            id="986030"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="775709"
                                              id="775709"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="373273"
                                                id="373273"
                                                xs={16}
                                                sm={16}
                                                md={16}
                                                lg={16}
                                                xl={16}
                                                xxl={16}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="740991"
                                                  id="740991"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    740991,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="677221"
                                                id="677221"
                                                xs={8}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={8}
                                                xxl={8}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="24899"
                                                  id="24899"
                                                  iconName="info"
                                                  iconLibrary="material"
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 7,
                                                      borderTopRightRadius: 7,
                                                      borderBottomRightRadius: 7,
                                                      borderBottomLeftRadius: 7,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(251, 18, 22, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="916089"
                                              id="916089"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="594758"
                                                id="594758"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 16,
                                                    paddingRight: 16,
                                                    paddingBottom: 0,
                                                    paddingLeft: 16,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="105818"
                                                  id="105818"
                                                  value={
                                                    this.state.ToplamRevizeBekleyenTeklif?.at?.(
                                                      0
                                                    )?.toplamTeklif ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Montserrat",
                                                      fontWeight: 600,
                                                      fontSize: "20px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="610552"
                                              id="610552"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="694132"
                                                id="694132"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="865161"
                                                  id="865161"
                                                  direction="horizontal"
                                                  size={8}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="985800"
                                                    id="985800"
                                                    iconName="arrow_forward_ios"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="712762"
                                                    id="712762"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      712762,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                      <KCol
                                        key="868338"
                                        id="868338"
                                        xs={24}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={8}
                                        xxl={8}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "flex-start",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="322011"
                                          id="322011"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="621556"
                                            id="621556"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="836"
                                              id="836"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="673213"
                                                id="673213"
                                                xs={16}
                                                sm={16}
                                                md={16}
                                                lg={16}
                                                xl={16}
                                                xxl={16}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="628432"
                                                  id="628432"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    628432,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                              <KCol
                                                key="630918"
                                                id="630918"
                                                xs={8}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={8}
                                                xxl={8}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Icon
                                                  key="377157"
                                                  id="377157"
                                                  iconName="check_circle"
                                                  iconLibrary="material"
                                                  style={
                                                    {
                                                      borderTopLeftRadius: 7,
                                                      borderTopRightRadius: 7,
                                                      borderBottomRightRadius: 7,
                                                      borderBottomLeftRadius: 7,
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      backgroundColor:
                                                        "rgba(251, 18, 22, 1)",
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "20px",
                                                      color:
                                                        "rgba(255, 255, 255, 1)",
                                                      letterSpacing: "1px",
                                                    } as any
                                                  }
                                                ></Icon>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="316664"
                                              id="316664"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="282554"
                                                id="282554"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 16,
                                                    paddingRight: 16,
                                                    paddingBottom: 0,
                                                    paddingLeft: 16,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="242304"
                                                  id="242304"
                                                  value={
                                                    this.state.ToplamOnayBekleyenTeklifler?.at?.(
                                                      0
                                                    )?.toplamTeklif ?? undefined
                                                  }
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Montserrat",
                                                      fontWeight: 600,
                                                      fontSize: "20px",
                                                      color: "rgba(0, 0, 0, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                            <KRow
                                              key="95517"
                                              id="95517"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="245484"
                                                id="245484"
                                                xs={24}
                                                sm={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="987088"
                                                  id="987088"
                                                  direction="horizontal"
                                                  size={8}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="994844"
                                                    id="994844"
                                                    iconName="arrow_forward_ios"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="9826"
                                                    id="9826"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      9826,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(144, 144, 144, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="454750"
                                  id="454750"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 0,
                                      paddingBottom: 8,
                                      paddingLeft: 0,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="262745"
                                    id="262745"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KPanel
                                      key="420165"
                                      id="420165"
                                      scrolling="hidden"
                                      scrollRadius={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 10,
                                          borderTopRightRadius: 10,
                                          borderBottomRightRadius: 10,
                                          borderBottomLeftRadius: 10,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          boxShadow:
                                            "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          maxHeight: "410px",
                                          minHeight: "410px",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="64873"
                                        id="64873"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="480655"
                                          id="480655"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="235763"
                                            id="235763"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            xxl={12}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="34775"
                                              id="34775"
                                              direction="vertical"
                                              size={4}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="105990"
                                                id="105990"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  105990,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                              <Label
                                                key="372672"
                                                id="372672"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  372672,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></Label>
                                            </VerticalStack>
                                          </KCol>
                                          <KCol
                                            key="200971"
                                            id="200971"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            xxl={12}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-right",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="294677"
                                              id="294677"
                                              onClick={(e?: any) => {
                                                if (e && e.stopPropagation)
                                                  e.stopPropagation();
                                                this.AnaSayfaComponent_294677_onClick();
                                              }}
                                              showCursorPointer
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                294677,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 10,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(72, 72, 72, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KCol>
                                        </KRow>
                                        <KRow
                                          key="429917"
                                          id="429917"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="244448"
                                            id="244448"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTable
                                              key="104013"
                                              id="104013"
                                              kuikaRef={
                                                this
                                                  .anasayfa_104013_value_kuikaTableRef
                                              }
                                              form={this.props.form}
                                              dataSource={
                                                this.state.Top5SiparisDesc
                                              }
                                              size="middle"
                                              bordered={true}
                                              loading={false}
                                              rowKey="id"
                                              transformedOnMobileResolution={
                                                false
                                              }
                                              hideHeaderOnMobileResolution={
                                                false
                                              }
                                              showHeader={true}
                                              fixedHeader={false}
                                              editable={false}
                                              tableWidthMode="fit"
                                              globalSearch={false}
                                              searchable={false}
                                              shouldSearchOnChange={true}
                                              searchDelay={200}
                                              sorter={false}
                                              filtering={false}
                                              pagination={false}
                                              pageSize={10}
                                              showSizeChanger={false}
                                              columnChooser={false}
                                              resizableColumns={false}
                                              striped={false}
                                              stripedColor="#F5F7FA"
                                              rowHoverBgColor="#fafafa"
                                              insertRowActive={false}
                                              insertRowPosition="top"
                                              showNoDataFound={true}
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                104013,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              multiSelect={false}
                                              multiSelectScope="page"
                                              export={false}
                                              editableAlwaysActive={false}
                                              paginationSelectedTextColor="#246eff"
                                              paginationUnselectedTextColor="#000"
                                              showRowNumbers={false}
                                              style={
                                                {
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableHeader
                                                key="208133"
                                                id="208133"
                                                hideOnMobileResolution={false}
                                                textDirection="Default"
                                                style={
                                                  {
                                                    borderColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></KTableHeader>
                                              <KTableRow
                                                key="722203"
                                                id="722203"
                                                hoverFontColor="red"
                                                hoverBgColor="#F5F5F5"
                                                style={
                                                  {
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KTableColumn
                                                  key="448502"
                                                  id="448502"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    448502,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="125698"
                                                    id="125698"
                                                    value="[datafield:siparisTarihi]"
                                                    formatter="date"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="283195"
                                                  id="283195"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    283195,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="175313"
                                                    id="175313"
                                                    value="[datafield:siparisNumarasi]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="985889"
                                                  id="985889"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    985889,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="392132"
                                                    id="392132"
                                                    value="[datafield:paraSembol]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="465920"
                                                    id="465920"
                                                    value="[datafield:genelToplam]"
                                                    formatter="money"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="984470"
                                                  id="984470"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    984470,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign:
                                                        "-webkit-center",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KPanel
                                                    key="44922"
                                                    id="44922"
                                                    scrolling="hidden"
                                                    scrollRadius={false}
                                                    dynamicBackGroundColor="#DFFAC7"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="185849"
                                                      id="185849"
                                                      visibility={
                                                        this.state
                                                          .isComp185849Visible
                                                      }
                                                      visibilityCondition={(
                                                        rowData: object
                                                      ) =>
                                                        ReactSystemFunctions.isEqualTo(
                                                          rowData.siparisDurum,
                                                          "1"
                                                        )
                                                      }
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        185849,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 4,
                                                          borderTopRightRadius: 4,
                                                          borderBottomRightRadius: 4,
                                                          borderBottomLeftRadius: 4,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 4,
                                                          paddingRight: 12,
                                                          paddingBottom: 4,
                                                          paddingLeft: 12,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KPanel>
                                                  <KPanel
                                                    key="963896"
                                                    id="963896"
                                                    scrolling="hidden"
                                                    scrollRadius={false}
                                                    dynamicBackGroundColor="#f3a91654"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="9628"
                                                      id="9628"
                                                      visibility={
                                                        this.state
                                                          .isComp9628Visible
                                                      }
                                                      visibilityCondition={(
                                                        rowData: object
                                                      ) =>
                                                        ReactSystemFunctions.isNotEqualTo(
                                                          rowData.siparisDurum,
                                                          "1"
                                                        )
                                                      }
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        9628,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 4,
                                                          borderTopRightRadius: 4,
                                                          borderBottomRightRadius: 4,
                                                          borderBottomLeftRadius: 4,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 4,
                                                          paddingRight: 12,
                                                          paddingBottom: 4,
                                                          paddingLeft: 12,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KPanel>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="635112"
                                                  id="635112"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    635112,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="175967"
                                                    id="175967"
                                                    onClick={(e?: any) => {
                                                      if (
                                                        e &&
                                                        e.stopPropagation
                                                      )
                                                        e.stopPropagation();
                                                      this.AnaSayfaComponent_175967_onClick();
                                                    }}
                                                    showCursorPointer
                                                    iconName="add_circle"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 7,
                                                        borderTopRightRadius: 7,
                                                        borderBottomRightRadius: 7,
                                                        borderBottomLeftRadius: 7,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 1)",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(255, 255, 255, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                </KTableColumn>
                                              </KTableRow>
                                            </KTable>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KPanel>
                                  </KCol>
                                  <KCol
                                    key="651794"
                                    id="651794"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KPanel
                                      key="868980"
                                      id="868980"
                                      scrolling="hidden"
                                      scrollRadius={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 10,
                                          borderTopRightRadius: 10,
                                          borderBottomRightRadius: 10,
                                          borderBottomLeftRadius: 10,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          boxShadow:
                                            "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          maxHeight: "410px",
                                          minHeight: "410px",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="533049"
                                        id="533049"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="915872"
                                          id="915872"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="810351"
                                            id="810351"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            xxl={12}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="520259"
                                              id="520259"
                                              direction="vertical"
                                              size={4}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="776288"
                                                id="776288"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  776288,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                              <Label
                                                key="6470"
                                                id="6470"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  6470,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></Label>
                                            </VerticalStack>
                                          </KCol>
                                          <KCol
                                            key="250799"
                                            id="250799"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            xxl={12}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-right",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="134673"
                                              id="134673"
                                              onClick={(e?: any) => {
                                                if (e && e.stopPropagation)
                                                  e.stopPropagation();
                                                this.AnaSayfaComponent_134673_onClick();
                                              }}
                                              showCursorPointer
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                134673,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 10,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(72, 72, 72, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KCol>
                                        </KRow>
                                        <KRow
                                          key="448342"
                                          id="448342"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="907973"
                                            id="907973"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTable
                                              key="530498"
                                              id="530498"
                                              kuikaRef={
                                                this
                                                  .anasayfa_530498_value_kuikaTableRef
                                              }
                                              form={this.props.form}
                                              dataSource={
                                                this.state.SepetteBekleyen5Stok
                                              }
                                              size="middle"
                                              bordered={true}
                                              loading={false}
                                              rowKey="id"
                                              transformedOnMobileResolution={
                                                false
                                              }
                                              hideHeaderOnMobileResolution={
                                                false
                                              }
                                              showHeader={true}
                                              fixedHeader={false}
                                              editable={false}
                                              tableWidthMode="fit"
                                              globalSearch={false}
                                              searchable={false}
                                              shouldSearchOnChange={true}
                                              searchDelay={200}
                                              sorter={false}
                                              filtering={false}
                                              pagination={false}
                                              pageSize={10}
                                              showSizeChanger={false}
                                              paginationSelectedTextColor="#246eff"
                                              paginationUnselectedTextColor="#000"
                                              columnChooser={false}
                                              resizableColumns={false}
                                              striped={false}
                                              stripedColor="#F5F7FA"
                                              rowHoverBgColor="#fafafa"
                                              insertRowActive={false}
                                              insertRowPosition="top"
                                              showNoDataFound={true}
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                530498,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              multiSelect={false}
                                              multiSelectScope="page"
                                              export={false}
                                              editableAlwaysActive={false}
                                              showRowNumbers={false}
                                              style={
                                                {
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableHeader
                                                key="201167"
                                                id="201167"
                                                hideOnMobileResolution={false}
                                                textDirection="Default"
                                                style={
                                                  {
                                                    borderColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></KTableHeader>
                                              <KTableRow
                                                key="333924"
                                                id="333924"
                                                hoverFontColor="red"
                                                hoverBgColor="#F5F5F5"
                                                style={
                                                  {
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KTableColumn
                                                  key="611468"
                                                  id="611468"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    611468,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="337967"
                                                    id="337967"
                                                    value="[datafield:eklemeTarihi]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="545685"
                                                  id="545685"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    545685,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="241076"
                                                    id="241076"
                                                    value="[datafield:musteriMarka]"
                                                    formatter="date"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="27018"
                                                  id="27018"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    27018,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="765224"
                                                    id="765224"
                                                    value="[datafield:stokKodu]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="840302"
                                                  id="840302"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    840302,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="382192"
                                                    id="382192"
                                                    value="[datafield:stokAdi]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                              </KTableRow>
                                            </KTable>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KPanel>
                                  </KCol>
                                  <KCol
                                    key="610456"
                                    id="610456"
                                    visibility={this.state.isComp610456Visible}
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KPanel
                                      key="106848"
                                      id="106848"
                                      scrolling="hidden"
                                      scrollRadius={false}
                                      style={
                                        {
                                          borderTopLeftRadius: 10,
                                          borderTopRightRadius: 10,
                                          borderBottomRightRadius: 10,
                                          borderBottomLeftRadius: 10,
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          boxShadow:
                                            "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 1)",
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          maxHeight: "410px",
                                          minHeight: "410px",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="531054"
                                        id="531054"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="60976"
                                          id="60976"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 16,
                                              paddingBottom: 8,
                                              paddingLeft: 16,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="956705"
                                            id="956705"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            xxl={12}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <VerticalStack
                                              key="961764"
                                              id="961764"
                                              direction="vertical"
                                              size={4}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <Label
                                                key="769147"
                                                id="769147"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  769147,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              ></Label>
                                              <Label
                                                key="880811"
                                                id="880811"
                                                value={ReactSystemFunctions.translate(
                                                  this.ml,
                                                  880811,
                                                  "value",
                                                  this.defaultML
                                                )}
                                                writingMode="horizontal"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></Label>
                                            </VerticalStack>
                                          </KCol>
                                          <KCol
                                            key="761553"
                                            id="761553"
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            xxl={12}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-right",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <Label
                                              key="342678"
                                              id="342678"
                                              value={ReactSystemFunctions.translate(
                                                this.ml,
                                                342678,
                                                "value",
                                                this.defaultML
                                              )}
                                              writingMode="horizontal"
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 10,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-left",
                                                  display: "inline",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(72, 72, 72, 1)",
                                                } as any
                                              }
                                            ></Label>
                                          </KCol>
                                        </KRow>
                                        <KRow
                                          key="211830"
                                          id="211830"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="508494"
                                            id="508494"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KTable
                                              key="87951"
                                              id="87951"
                                              kuikaRef={
                                                this
                                                  .anasayfa_87951_value_kuikaTableRef
                                              }
                                              form={this.props.form}
                                              dataSource={this.state.Top5Teklif}
                                              size="middle"
                                              bordered={true}
                                              loading={false}
                                              rowKey="id"
                                              transformedOnMobileResolution={
                                                false
                                              }
                                              hideHeaderOnMobileResolution={
                                                false
                                              }
                                              showHeader={true}
                                              fixedHeader={false}
                                              editable={false}
                                              tableWidthMode="fit"
                                              globalSearch={false}
                                              searchable={false}
                                              shouldSearchOnChange={true}
                                              searchDelay={200}
                                              sorter={false}
                                              filtering={false}
                                              pagination={false}
                                              pageSize={10}
                                              showSizeChanger={false}
                                              paginationSelectedTextColor="#246eff"
                                              paginationUnselectedTextColor="#000"
                                              columnChooser={false}
                                              resizableColumns={false}
                                              striped={false}
                                              stripedColor="#F5F7FA"
                                              rowHoverBgColor="#fafafa"
                                              insertRowActive={false}
                                              insertRowPosition="top"
                                              showNoDataFound={true}
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                87951,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              multiSelect={false}
                                              multiSelectScope="page"
                                              export={false}
                                              editableAlwaysActive={false}
                                              showRowNumbers={false}
                                              style={
                                                {
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KTableHeader
                                                key="913069"
                                                id="913069"
                                                hideOnMobileResolution={false}
                                                textDirection="Default"
                                                style={
                                                  {
                                                    borderColor:
                                                      "rgba(255, 255, 255, 1)",
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color:
                                                      "rgba(155, 155, 155, 1)",
                                                    lineHeight: "20px",
                                                  } as any
                                                }
                                              ></KTableHeader>
                                              <KTableRow
                                                key="628822"
                                                id="628822"
                                                hoverFontColor="red"
                                                hoverBgColor="#F5F5F5"
                                                style={
                                                  {
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KTableColumn
                                                  key="310097"
                                                  id="310097"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    310097,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="198564"
                                                    id="198564"
                                                    value="[datafield:teklifTarihi]"
                                                    formatter="date"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="281731"
                                                  id="281731"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    281731,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="443449"
                                                    id="443449"
                                                    value="[datafield:teklifNumarasi]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="71014"
                                                  id="71014"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    71014,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="951392"
                                                    id="951392"
                                                    value="[datafield:paraSembol]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="948978"
                                                    id="948978"
                                                    value="[datafield:genelToplam]"
                                                    formatter="money"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="755105"
                                                  id="755105"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    755105,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign:
                                                        "-webkit-center",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KPanel
                                                    key="787972"
                                                    id="787972"
                                                    scrolling="hidden"
                                                    scrollRadius={false}
                                                    dynamicBackGroundColor="[datafield:renk]"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 8,
                                                        borderTopRightRadius: 8,
                                                        borderBottomRightRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="272885"
                                                      id="272885"
                                                      value="[datafield:teklifDurumu]"
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 4,
                                                          borderTopRightRadius: 4,
                                                          borderBottomRightRadius: 4,
                                                          borderBottomLeftRadius: 4,
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 4,
                                                          paddingRight: 12,
                                                          paddingBottom: 4,
                                                          paddingLeft: 12,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 400,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    ></Label>
                                                  </KPanel>
                                                </KTableColumn>
                                                <KTableColumn
                                                  key="230748"
                                                  id="230748"
                                                  title={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    230748,
                                                    "title",
                                                    this.defaultML
                                                  )}
                                                  alwaysVisibleOnMobileResolution={
                                                    false
                                                  }
                                                  hideFiltering={false}
                                                  hideSorting={false}
                                                  hideSearch={false}
                                                  footerOptions="none"
                                                  footerFontSize={14}
                                                  footerFontColor="rgb(68, 68, 68)"
                                                  excludeFromExport={false}
                                                  footerFontWeight="Regular"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="104913"
                                                    id="104913"
                                                    iconName="add_circle"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderTopLeftRadius: 7,
                                                        borderTopRightRadius: 7,
                                                        borderBottomRightRadius: 7,
                                                        borderBottomLeftRadius: 7,
                                                        borderTopWidth: 1,
                                                        borderRightWidth: 1,
                                                        borderBottomWidth: 1,
                                                        borderLeftWidth: 1,
                                                        borderColor:
                                                          "rgba(218, 218, 218, 1)",
                                                        borderStyle: "solid",
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 1)",
                                                        paddingTop: 8,
                                                        paddingRight: 8,
                                                        paddingBottom: 8,
                                                        paddingLeft: 8,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(255, 255, 255, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                </KTableColumn>
                                              </KTableRow>
                                            </KTable>
                                          </KCol>
                                        </KRow>
                                      </KCol>
                                    </KPanel>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                            <KRow
                              key="892232"
                              id="892232"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 8,
                                  paddingBottom: 8,
                                  paddingLeft: 8,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="134896"
                                id="134896"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 8,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KRow
                                  key="206247"
                                  id="206247"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="54479"
                                    id="54479"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KRow
                                      key="866950"
                                      id="866950"
                                      align="top"
                                      justify="start"
                                      horizontalGutter={0}
                                      verticalGutter={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KCol
                                        key="602799"
                                        id="602799"
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        order={0}
                                        pull={0}
                                        push={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="596979"
                                          id="596979"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderTopLeftRadius: 14,
                                              borderTopRightRadius: 14,
                                              borderBottomRightRadius: 14,
                                              borderBottomLeftRadius: 14,
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              boxShadow:
                                                "0px 3px 9px 0px rgba(217, 217, 217, 1)",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              paddingTop: 15,
                                              paddingRight: 15,
                                              paddingBottom: 15,
                                              paddingLeft: 15,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="476446"
                                            id="476446"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderTopLeftRadius: 8,
                                                borderTopRightRadius: 8,
                                                borderBottomRightRadius: 8,
                                                borderBottomLeftRadius: 8,
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KRow
                                              key="920771"
                                              id="920771"
                                              align="top"
                                              justify="start"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 16,
                                                  paddingBottom: 8,
                                                  paddingLeft: 16,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KCol
                                                key="729092"
                                                id="729092"
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                                xxl={12}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <VerticalStack
                                                  key="917159"
                                                  id="917159"
                                                  direction="vertical"
                                                  size={4}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="829135"
                                                    id="829135"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      829135,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="169963"
                                                    id="169963"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      169963,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </VerticalStack>
                                              </KCol>
                                              <KCol
                                                key="484376"
                                                id="484376"
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                                xxl={12}
                                                order={0}
                                                pull={0}
                                                push={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-right",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="49717"
                                                  id="49717"
                                                  onClick={(e?: any) => {
                                                    if (e && e.stopPropagation)
                                                      e.stopPropagation();
                                                    this.AnaSayfaComponent_49717_onClick();
                                                  }}
                                                  showCursorPointer
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    49717,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 10,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(72, 72, 72, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </KCol>
                                            </KRow>
                                          </KCol>
                                          <KCol
                                            key="607729"
                                            id="607729"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          >
                                            <KGallery
                                              key="34385"
                                              id="34385"
                                              kuikaRef={
                                                this
                                                  .anasayfa_34385_value_kuikaGalleryViewRef
                                              }
                                              nodatafoundmessage={ReactSystemFunctions.translate(
                                                this.ml,
                                                34385,
                                                "nodatafoundmessage",
                                                this.defaultML
                                              )}
                                              dataSource={
                                                this.state.GetYeniUrunler
                                              }
                                              loading={false}
                                              phoneColumnsCount={1}
                                              tabletColumnsCount={2}
                                              desktopColumnsCount={6}
                                              hoverFontColor="black"
                                              hoverBgColor="white"
                                              horizontalGutter={0}
                                              verticalGutter={0}
                                              showNoDataFoundImage={false}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  fontFamily: "Poppins",
                                                  fontWeight: 500,
                                                  fontSize: "14px",
                                                  color: "rgba(68, 68, 68, 1)",
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="634979"
                                                id="634979"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="780339"
                                                  id="780339"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={24}
                                                  xxl={24}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 0,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 500,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="339132"
                                                    id="339132"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="284406"
                                                      id="284406"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderTopLeftRadius: 15,
                                                          borderTopRightRadius: 15,
                                                          borderBottomRightRadius: 15,
                                                          borderBottomLeftRadius: 15,
                                                          borderColor:
                                                            "rgba(72, 72, 72, 1)",
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <KRow
                                                        key="210705"
                                                        id="210705"
                                                        align="top"
                                                        justify="start"
                                                        horizontalGutter={0}
                                                        verticalGutter={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <KCol
                                                          key="244302"
                                                          id="244302"
                                                          xs={24}
                                                          sm={24}
                                                          md={24}
                                                          lg={24}
                                                          xl={24}
                                                          xxl={24}
                                                          order={0}
                                                          pull={0}
                                                          push={0}
                                                          style={
                                                            {
                                                              borderTopLeftRadius: 15,
                                                              borderTopRightRadius: 15,
                                                              borderBottomRightRadius: 15,
                                                              borderBottomLeftRadius: 15,
                                                              borderTopWidth: 1,
                                                              borderRightWidth: 1,
                                                              borderBottomWidth: 1,
                                                              borderLeftWidth: 1,
                                                              borderColor:
                                                                "rgba(217, 217, 217, 0.37)",
                                                              borderStyle:
                                                                "solid",
                                                              paddingTop: 0,
                                                              paddingRight: 8,
                                                              paddingBottom: 8,
                                                              paddingLeft: 8,
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign:
                                                                "-webkit-center",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Form.Item
                                                            className="kFormItem"
                                                            name="anasayfa_453574_value"
                                                          >
                                                            <Image
                                                              key="453574"
                                                              id="453574"
                                                              value="[datafield:kapakResim]"
                                                              placeHolderImage="f4b5fbbd-9e25-402c-9581-08dd8e436860"
                                                              zoomOnClick={
                                                                false
                                                              }
                                                              imageFit="fit"
                                                              style={
                                                                {
                                                                  borderTopLeftRadius: 10,
                                                                  borderTopRightRadius: 10,
                                                                  borderBottomRightRadius: 10,
                                                                  borderBottomLeftRadius: 10,
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  width:
                                                                    "160px",
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "rgba(68, 68, 68, 1)",
                                                                } as any
                                                              }
                                                            ></Image>
                                                          </Form.Item>
                                                        </KCol>
                                                      </KRow>
                                                      <KRow
                                                        key="143833"
                                                        id="143833"
                                                        align="top"
                                                        justify="start"
                                                        horizontalGutter={0}
                                                        verticalGutter={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 8,
                                                            paddingBottom: 0,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <KCol
                                                          key="296392"
                                                          id="296392"
                                                          xs={12}
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xl={12}
                                                          xxl={12}
                                                          order={0}
                                                          pull={0}
                                                          push={0}
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 15,
                                                              paddingRight: 8,
                                                              paddingBottom: 0,
                                                              paddingLeft: 8,
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign:
                                                                "-webkit-left",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <HorizontalStack
                                                            key="901279"
                                                            id="901279"
                                                            direction="horizontal"
                                                            size={1}
                                                            overflowX="auto"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="351328"
                                                              id="351328"
                                                              value={
                                                                this.state.GetCariParaBirimi?.at?.(
                                                                  0
                                                                )?.paraSembol ??
                                                                undefined
                                                              }
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 5,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Montserrat",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "13px",
                                                                  color:
                                                                    "rgba(0, 0, 0, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                            <Label
                                                              key="66368"
                                                              id="66368"
                                                              value="[datafield:fiyat]"
                                                              formatter="money"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Montserrat",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "13px",
                                                                  color:
                                                                    "rgba(72, 72, 72, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </HorizontalStack>
                                                        </KCol>
                                                        <KCol
                                                          key="405499"
                                                          id="405499"
                                                          xs={12}
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xl={12}
                                                          xxl={12}
                                                          order={0}
                                                          pull={0}
                                                          push={0}
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 8,
                                                              paddingRight: 8,
                                                              paddingBottom: 0,
                                                              paddingLeft: 8,
                                                              alignItems:
                                                                "center",
                                                              textAlign:
                                                                "-webkit-right",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Tooltip
                                                            key="741887"
                                                            id="741887"
                                                            visibility={
                                                              this.state
                                                                .isComp741887Visible
                                                            }
                                                            visibilityCondition={(
                                                              rowData: object
                                                            ) =>
                                                              ReactSystemFunctions.isEqualTo(
                                                                rowData.adetBazliFiyatVarMi,
                                                                "true"
                                                              )
                                                            }
                                                            title="[datafield:adetBazliFiyatAciklama]"
                                                            placement="top"
                                                            style={
                                                              {
                                                                borderTopLeftRadius: 4,
                                                                borderTopRightRadius: 4,
                                                                borderBottomRightRadius: 4,
                                                                borderBottomLeftRadius: 4,
                                                                borderTopWidth: 1,
                                                                borderRightWidth: 1,
                                                                borderBottomWidth: 1,
                                                                borderLeftWidth: 1,
                                                                borderColor:
                                                                  "rgba(218, 218, 218, 1)",
                                                                borderStyle:
                                                                  "solid",
                                                                backgroundColor:
                                                                  "rgba(255, 255, 255, 1)",
                                                                backgroundRepeat:
                                                                  "no-repeat",
                                                                backgroundSize:
                                                                  "contain",
                                                                backgroundPosition:
                                                                  "left",
                                                                paddingTop: 8,
                                                                paddingRight: 8,
                                                                paddingBottom: 8,
                                                                paddingLeft: 8,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(155, 155, 155, 1)",
                                                                lineHeight:
                                                                  "20px",
                                                              } as any
                                                            }
                                                          >
                                                            <Form.Item
                                                              className="kFormItem"
                                                              name="anasayfa_759816_value"
                                                            >
                                                              <Image
                                                                key="759816"
                                                                id="759816"
                                                                value="6ba68c00-24bc-4d8c-6d9a-08de0b486d08"
                                                                zoomOnClick={
                                                                  false
                                                                }
                                                                imageFit="fit"
                                                                style={
                                                                  {
                                                                    borderStyle:
                                                                      "solid",
                                                                    borderTopWidth: 0,
                                                                    borderRightWidth: 0,
                                                                    borderBottomWidth: 0,
                                                                    borderLeftWidth: 0,
                                                                    paddingTop: 0,
                                                                    paddingRight: 0,
                                                                    paddingBottom: 0,
                                                                    paddingLeft: 0,
                                                                    width:
                                                                      "85px",
                                                                    alignItems:
                                                                      "center",
                                                                    textAlign:
                                                                      "-webkit-left",
                                                                    display:
                                                                      "inline",
                                                                    fontFamily:
                                                                      "Poppins",
                                                                    fontWeight: 500,
                                                                    fontSize:
                                                                      "14px",
                                                                    color:
                                                                      "rgba(68, 68, 68, 1)",
                                                                  } as any
                                                                }
                                                              ></Image>
                                                            </Form.Item>
                                                          </Tooltip>
                                                        </KCol>
                                                      </KRow>
                                                      <KRow
                                                        key="340216"
                                                        id="340216"
                                                        align="top"
                                                        justify="start"
                                                        horizontalGutter={0}
                                                        verticalGutter={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <KCol
                                                          key="413952"
                                                          id="413952"
                                                          xs={24}
                                                          sm={24}
                                                          md={24}
                                                          lg={24}
                                                          xl={24}
                                                          xxl={24}
                                                          order={0}
                                                          pull={0}
                                                          push={0}
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 8,
                                                              paddingBottom: 8,
                                                              paddingLeft: 8,
                                                              alignItems:
                                                                "flex-start",
                                                              textAlign:
                                                                "-webkit-left",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="956743"
                                                            id="956743"
                                                            value="[datafield:stoK_KODU]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Montserrat",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "11px",
                                                                color:
                                                                  "rgba(45, 45, 45, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <KCol
                                                            key="142881"
                                                            id="142881"
                                                            xs={24}
                                                            sm={24}
                                                            md={24}
                                                            lg={24}
                                                            xl={24}
                                                            xxl={24}
                                                            order={0}
                                                            pull={0}
                                                            push={0}
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="289790"
                                                              id="289790"
                                                              onChange={(
                                                                e?: any
                                                              ) => {
                                                                if (
                                                                  e &&
                                                                  e.stopPropagation
                                                                )
                                                                  e.stopPropagation();
                                                                this.AnaSayfaComponent_289790_onChange();
                                                              }}
                                                              value="[datafield:birlesmisstok]"
                                                              maxLine={1}
                                                              tooltip="[datafield:birlesmisstok]"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(45, 45, 45, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </KCol>
                                                        </KCol>
                                                      </KRow>
                                                      <KRow
                                                        key="62569"
                                                        id="62569"
                                                        align="top"
                                                        justify="start"
                                                        horizontalGutter={0}
                                                        verticalGutter={0}
                                                        style={
                                                          {
                                                            borderTopWidth: 1,
                                                            borderColor:
                                                              "rgba(244, 244, 244, 1)",
                                                            borderStyle:
                                                              "solid",
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <KCol
                                                          key="114564"
                                                          id="114564"
                                                          xs={24}
                                                          sm={24}
                                                          md={24}
                                                          lg={24}
                                                          xl={24}
                                                          xxl={24}
                                                          order={0}
                                                          pull={0}
                                                          push={0}
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              textAlign:
                                                                "-webkit-left",
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <KCol
                                                            key="882631"
                                                            id="882631"
                                                            xs={24}
                                                            sm={24}
                                                            md={24}
                                                            lg={24}
                                                            xl={24}
                                                            xxl={24}
                                                            order={0}
                                                            pull={0}
                                                            push={0}
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <KRow
                                                              key="673958"
                                                              id="673958"
                                                              align="top"
                                                              justify="start"
                                                              horizontalGutter={
                                                                0
                                                              }
                                                              verticalGutter={0}
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  fontFamily:
                                                                    "Poppins",
                                                                  fontWeight: 500,
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "rgba(68, 68, 68, 1)",
                                                                } as any
                                                              }
                                                            >
                                                              <KCol
                                                                key="123307"
                                                                id="123307"
                                                                xs={24}
                                                                sm={24}
                                                                md={24}
                                                                lg={24}
                                                                xl={12}
                                                                xxl={12}
                                                                order={0}
                                                                pull={0}
                                                                push={0}
                                                                style={
                                                                  {
                                                                    borderStyle:
                                                                      "solid",
                                                                    borderTopWidth: 0,
                                                                    borderRightWidth: 0,
                                                                    borderBottomWidth: 0,
                                                                    borderLeftWidth: 0,
                                                                    paddingTop: 8,
                                                                    paddingRight: 8,
                                                                    paddingBottom: 20,
                                                                    paddingLeft: 8,
                                                                    alignItems:
                                                                      "flex-start",
                                                                    textAlign:
                                                                      "-webkit-left",
                                                                    fontFamily:
                                                                      "Poppins",
                                                                    fontWeight: 500,
                                                                    fontSize:
                                                                      "14px",
                                                                    color:
                                                                      "rgba(68, 68, 68, 1)",
                                                                  } as any
                                                                }
                                                              >
                                                                <Button
                                                                  key="655743"
                                                                  id="655743"
                                                                  onClick={(
                                                                    e?: any
                                                                  ) => {
                                                                    if (
                                                                      e &&
                                                                      e.stopPropagation
                                                                    )
                                                                      e.stopPropagation();
                                                                    this.AnaSayfaComponent_655743_onClick();
                                                                  }}
                                                                  showCursorPointer
                                                                  label={ReactSystemFunctions.translate(
                                                                    this.ml,
                                                                    655743,
                                                                    "label",
                                                                    this
                                                                      .defaultML
                                                                  )}
                                                                  size="middle"
                                                                  loading={
                                                                    false
                                                                  }
                                                                  ghost={false}
                                                                  block={false}
                                                                  htmlType="button"
                                                                  iconPosition="left"
                                                                  danger={false}
                                                                  iconLibrary="material"
                                                                  style={
                                                                    {
                                                                      borderTopLeftRadius: 10,
                                                                      borderTopRightRadius: 10,
                                                                      borderBottomRightRadius: 10,
                                                                      borderBottomLeftRadius: 10,
                                                                      borderTopWidth: 1,
                                                                      borderRightWidth: 1,
                                                                      borderBottomWidth: 1,
                                                                      borderLeftWidth: 1,
                                                                      borderColor:
                                                                        "rgba(144, 144, 144, 0.15)",
                                                                      paddingTop: 8,
                                                                      paddingRight: 16,
                                                                      paddingBottom: 8,
                                                                      paddingLeft: 16,
                                                                      height:
                                                                        "35px",
                                                                      alignItems:
                                                                        "center",
                                                                      textAlign:
                                                                        "-webkit-center",
                                                                      display:
                                                                        "inline",
                                                                      fontFamily:
                                                                        "Poppins",
                                                                      fontWeight: 400,
                                                                      fontSize:
                                                                        "10px",
                                                                      color:
                                                                        "rgba(0, 0, 0, 1)",
                                                                      lineHeight:
                                                                        "5px",
                                                                    } as any
                                                                  }
                                                                ></Button>
                                                              </KCol>
                                                              <KCol
                                                                key="847036"
                                                                id="847036"
                                                                xs={24}
                                                                sm={24}
                                                                md={24}
                                                                lg={24}
                                                                xl={12}
                                                                xxl={12}
                                                                order={0}
                                                                pull={0}
                                                                push={0}
                                                                style={
                                                                  {
                                                                    borderStyle:
                                                                      "solid",
                                                                    borderTopWidth: 0,
                                                                    borderRightWidth: 0,
                                                                    borderBottomWidth: 0,
                                                                    borderLeftWidth: 0,
                                                                    paddingTop: 8,
                                                                    paddingRight: 8,
                                                                    paddingBottom: 8,
                                                                    paddingLeft: 8,
                                                                    alignItems:
                                                                      "flex-start",
                                                                    textAlign:
                                                                      "-webkit-right",
                                                                    fontFamily:
                                                                      "Poppins",
                                                                    fontWeight: 500,
                                                                    fontSize:
                                                                      "14px",
                                                                    color:
                                                                      "rgba(68, 68, 68, 1)",
                                                                  } as any
                                                                }
                                                              >
                                                                <HorizontalStack
                                                                  key="63725"
                                                                  id="63725"
                                                                  direction="horizontal"
                                                                  size={5}
                                                                  overflowX="auto"
                                                                  style={
                                                                    {
                                                                      borderStyle:
                                                                        "solid",
                                                                      borderTopWidth: 0,
                                                                      borderRightWidth: 0,
                                                                      borderBottomWidth: 0,
                                                                      borderLeftWidth: 0,
                                                                      paddingTop: 0,
                                                                      paddingRight: 0,
                                                                      paddingBottom: 0,
                                                                      paddingLeft: 0,
                                                                      fontFamily:
                                                                        "Poppins",
                                                                      fontWeight: 500,
                                                                      fontSize:
                                                                        "14px",
                                                                      color:
                                                                        "rgba(68, 68, 68, 1)",
                                                                    } as any
                                                                  }
                                                                >
                                                                  <Icon
                                                                    key="487899"
                                                                    id="487899"
                                                                    onClick={(
                                                                      e?: any
                                                                    ) => {
                                                                      if (
                                                                        e &&
                                                                        e.stopPropagation
                                                                      )
                                                                        e.stopPropagation();
                                                                      this.AnaSayfaComponent_487899_onClick();
                                                                    }}
                                                                    showCursorPointer
                                                                    visibility={
                                                                      this.state
                                                                        .isComp487899Visible
                                                                    }
                                                                    visibilityCondition={(
                                                                      rowData: object
                                                                    ) =>
                                                                      ReactSystemFunctions.isEqualTo(
                                                                        this.state.GetParametreler[0]?.isTeklif?.toString(),
                                                                        "true"
                                                                      )
                                                                    }
                                                                    iconName="shopping_basket"
                                                                    hoverText="Teklif"
                                                                    iconLibrary="material"
                                                                    style={
                                                                      {
                                                                        borderTopLeftRadius: 7,
                                                                        borderTopRightRadius: 7,
                                                                        borderBottomRightRadius: 7,
                                                                        borderBottomLeftRadius: 7,
                                                                        borderTopWidth: 1,
                                                                        borderRightWidth: 1,
                                                                        borderBottomWidth: 1,
                                                                        borderLeftWidth: 1,
                                                                        borderColor:
                                                                          "rgba(218, 218, 218, 1)",
                                                                        borderStyle:
                                                                          "solid",
                                                                        backgroundColor:
                                                                          "rgba(0, 0, 0, 1)",
                                                                        paddingTop: 8,
                                                                        paddingRight: 8,
                                                                        paddingBottom: 8,
                                                                        paddingLeft: 8,
                                                                        alignItems:
                                                                          "center",
                                                                        textAlign:
                                                                          "-webkit-left",
                                                                        display:
                                                                          "inline",
                                                                        fontFamily:
                                                                          "Poppins",
                                                                        fontWeight: 500,
                                                                        fontSize:
                                                                          "14px",
                                                                        color:
                                                                          "rgba(255, 255, 255, 1)",
                                                                        letterSpacing:
                                                                          "1px",
                                                                      } as any
                                                                    }
                                                                  ></Icon>
                                                                  <Icon
                                                                    key="995804"
                                                                    id="995804"
                                                                    onClick={(
                                                                      e?: any
                                                                    ) => {
                                                                      if (
                                                                        e &&
                                                                        e.stopPropagation
                                                                      )
                                                                        e.stopPropagation();
                                                                      this.AnaSayfaComponent_995804_onClick();
                                                                    }}
                                                                    showCursorPointer
                                                                    iconName="add_shopping_cart"
                                                                    hoverText="Sipariş"
                                                                    iconLibrary="material"
                                                                    style={
                                                                      {
                                                                        borderTopLeftRadius: 7,
                                                                        borderTopRightRadius: 7,
                                                                        borderBottomRightRadius: 7,
                                                                        borderBottomLeftRadius: 7,
                                                                        borderColor:
                                                                          "rgba(178, 14, 14, 0.26)",
                                                                        borderStyle:
                                                                          "solid",
                                                                        borderTopWidth: 0,
                                                                        borderRightWidth: 0,
                                                                        borderBottomWidth: 0,
                                                                        borderLeftWidth: 0,
                                                                        backgroundColor:
                                                                          "rgba(252, 17, 22, 1)",
                                                                        paddingTop: 8,
                                                                        paddingRight: 8,
                                                                        paddingBottom: 8,
                                                                        paddingLeft: 8,
                                                                        alignItems:
                                                                          "center",
                                                                        textAlign:
                                                                          "-webkit-left",
                                                                        display:
                                                                          "inline",
                                                                        fontFamily:
                                                                          "Poppins",
                                                                        fontWeight: 500,
                                                                        fontSize:
                                                                          "15px",
                                                                        color:
                                                                          "rgba(255, 255, 255, 1)",
                                                                        letterSpacing:
                                                                          "1px",
                                                                      } as any
                                                                    }
                                                                  ></Icon>
                                                                </HorizontalStack>
                                                              </KCol>
                                                            </KRow>
                                                          </KCol>
                                                        </KCol>
                                                      </KRow>
                                                      <KRow
                                                        key="53827"
                                                        id="53827"
                                                        align="top"
                                                        justify="start"
                                                        horizontalGutter={0}
                                                        verticalGutter={0}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "flex-start",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      ></KRow>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                              </KRow>
                                            </KGallery>
                                          </KCol>
                                        </KRow>
                                        <KRow
                                          key="150118"
                                          id="150118"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="672135"
                                            id="672135"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></KCol>
                                        </KRow>
                                      </KCol>
                                    </KRow>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                          </KCol>
                        </KRow>
                      </KPanel>
                    </KCol>
                  </KRow>
                  <KDrawer
                    key="222082"
                    id="222082"
                    placement="right"
                    onClose={() => {
                      this.setState({ NavVisible222082: false }, () => {
                        this.callCallbackFunction(222082);
                      });
                    }}
                    visible={this.state.NavVisible222082}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible222082 && (
                        <InlineFormScope>
                          <SiparisSepetOzet_Screen
                            onClose={() => {
                              this.setState({ NavVisible222082: false }, () => {
                                this.callCallbackFunction(222082);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KModal
                    key="660300"
                    id="660300"
                    visible={this.state.NavVisible660300}
                    onOk={() => {
                      this.setState({ NavVisible660300: false }, () => {
                        this.callCallbackFunction(660300);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible660300: false }, () => {
                        this.callCallbackFunction(660300);
                      });
                    }}
                    closable={true}
                    width="400px"
                    footer={null}
                    height="38vh"
                    children={
                      this.state.NavVisible660300 && (
                        <InlineFormScope>
                          <SepetModal_Screen
                            onClose={() => {
                              this.setState({ NavVisible660300: false }, () => {
                                this.callCallbackFunction(660300);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KModal
                    key="234173"
                    id="234173"
                    visible={this.state.NavVisible234173}
                    onOk={() => {
                      this.setState({ NavVisible234173: false }, () => {
                        this.callCallbackFunction(234173);
                      });
                    }}
                    onCancel={() => {
                      this.setState({ NavVisible234173: false }, () => {
                        this.callCallbackFunction(234173);
                      });
                    }}
                    closable={true}
                    width="400px"
                    footer={null}
                    height="38vh"
                    children={
                      this.state.NavVisible234173 && (
                        <InlineFormScope>
                          <SepetModal_Screen
                            onClose={() => {
                              this.setState({ NavVisible234173: false }, () => {
                                this.callCallbackFunction(234173);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                  ></KModal>
                  <KDrawer
                    key="456055"
                    id="456055"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible456055: false }, () => {
                        this.callCallbackFunction(456055);
                      });
                    }}
                    visible={this.state.NavVisible456055}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible456055 && (
                        <InlineFormScope>
                          <ProoductDetail_Screen
                            onClose={() => {
                              this.setState({ NavVisible456055: false }, () => {
                                this.callCallbackFunction(456055);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KDrawer
                    key="480976"
                    id="480976"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible480976: false }, () => {
                        this.callCallbackFunction(480976);
                      });
                    }}
                    visible={this.state.NavVisible480976}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible480976 && (
                        <InlineFormScope>
                          <SiparisDetay_Screen
                            onClose={() => {
                              this.setState({ NavVisible480976: false }, () => {
                                this.callCallbackFunction(480976);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                  <KDrawer
                    key="769765"
                    id="769765"
                    placement="top"
                    onClose={() => {
                      this.setState({ NavVisible769765: false }, () => {
                        this.callCallbackFunction(769765);
                      });
                    }}
                    visible={this.state.NavVisible769765}
                    width="380px"
                    height="100vh"
                    push={true}
                    closable={true}
                    children={
                      this.state.NavVisible769765 && (
                        <InlineFormScope>
                          <ProoductDetail_Screen
                            onClose={() => {
                              this.setState({ NavVisible769765: false }, () => {
                                this.callCallbackFunction(769765);
                              });
                            }}
                            screenInputs={window.kuika.navigationScreenInputs}
                            navigator={this.props.navigator}
                            form={this.props.form}
                            context={this.props.context}
                          />
                        </InlineFormScope>
                      )
                    }
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  ></KDrawer>
                </div>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(mapStateToProps, mapDispatchToProps)(AnaSayfa_Screen)
          )
        )
      )
    )
  )
);
export { tmp as AnaSayfa_Screen };
//export default tmp;
//export { tmp as AnaSayfa_Screen };
